import { isSomething } from "../utils/langUtils";

const BREADCRUMP_SEPARATOR = "-";

export function extractInstrumentationType(rawInstrumentationType: $TSFixMe) {
  const tenantId = rawInstrumentationType.tenant
    ? rawInstrumentationType.tenant.id
    : null;
  const tenantName = rawInstrumentationType.tenant
    ? rawInstrumentationType.tenant.name
    : null;
  const tenantPublic = rawInstrumentationType.tenant
    ? rawInstrumentationType.tenant.public
    : null;

  return {
    id: rawInstrumentationType.id,
    name: rawInstrumentationType.name,
    code: rawInstrumentationType.code,
    tenantId,
    tenantPublic,
    tenantName,
    parentId: rawInstrumentationType.parent
      ? rawInstrumentationType.parent.id
      : null,
  };
}

// @ts-expect-error TS(7023) FIXME: 'buildDisplayNameForTree' implicitly has return ty... Remove this comment to see the full error message
function buildDisplayNameForTree(type: $TSFixMe) {
  if (isSomething(type.parent)) {
    return `${buildDisplayNameForTree(type.parent)} ${BREADCRUMP_SEPARATOR} ${type.name}`;
  }
  return type.name;
}

// @ts-expect-error TS(7023) FIXME: 'buildDisplayName' implicitly has return type 'any... Remove this comment to see the full error message
export function buildDisplayName(type: $TSFixMe, allTypes: $TSFixMe) {
  if (isSomething(type.parentId)) {
    const parent = allTypes.find((t: $TSFixMe) => t.id === type.parentId);
    if (parent.parentId) {
      return `${buildDisplayName(parent, allTypes)} ${BREADCRUMP_SEPARATOR} ${type.name}`;
    }
    return `${parent.name} ${BREADCRUMP_SEPARATOR} ${type.name}`;
  }
  return type.name;
}

export function extractInstrumentationTypes(
  rawTypes: $TSFixMe,
  buildBreadcrumbNames = false,
) {
  const mappedTypes = rawTypes.instrumentation_types.map((type: $TSFixMe) =>
    extractInstrumentationType(type),
  );
  if (buildBreadcrumbNames) {
    mappedTypes.forEach((type: $TSFixMe) => {
      /* eslint-disable no-param-reassign */
      type.displayName = buildDisplayName(type, mappedTypes);
    });
  }
  return mappedTypes;
}

export function extractInstrumentationTypeTree(
  rawInstrumentationType: $TSFixMe,
) {
  const type = extractInstrumentationType(rawInstrumentationType);
  (type as $TSFixMe).displayName = buildDisplayNameForTree(
    rawInstrumentationType,
  );
  return type;
}
